
const LabelText = (name) => {
  return name
    .split('_')
    .map((item) => [...item[0].toUpperCase(), ...item.slice(1, item.length)].join(''))
    .join(' ');
};

export default LabelText;
